import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'gains-layout',
  standalone: false,
  templateUrl: './gains-layout.component.html',
  styleUrl: './gains-layout.component.scss'
})
export class GainsLayoutComponent implements OnInit, OnDestroy {
  private _routerSubscription?: Subscription;

  constructor(private readonly router: Router) {}

  isLoginRoute(): boolean {
    // Checks for exact '/login' route
    return this.router.url === '/login';
  }

  /**
   * Routes that render without the app shell. /auth-callback is included because the sidenav
   * loads feature flags on init, and those are tenant-scoped — they must not be fetched until
   * the tenant switcher has resolved.
   */
  shouldHideAppShell(): boolean {
    return this.isLoginRoute() || this.isAuthCallbackRoute();
  }

  private isAuthCallbackRoute(): boolean {
    return this.currentPath() === '/auth-callback';
  }

  private currentPath(): string {
    return this.router.url.split(/[?#]/)[0];
  }
  isCollapsed = true;
  hoverTimeout: any;
  breadcrumbs = Array<any>;
  isMouseOverDropdown = false;
  profileDropDownClass = 'custom-profile-dropdown';

  ngOnInit(): void {
    this._routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => this.closeNavbarInstantly());
  }

  @HostListener('document:mouseover', ['$event'])
  onDocumentMouseOver(event: MouseEvent) {
    if (!event || !event.target) {
      return;
    }
    const target = event.target as HTMLElement;
    // Check if mouse is over a dropdown menu
    this.isMouseOverDropdown = !!target.closest('.custom-profile-dropdown, .ant-dropdown, .ant-dropdown-menu');
  }

  onMouseEnter() {
    this.clearHoverTimeout();
    this.isCollapsed = false;
  }

  onMouseLeave() {
    this.clearHoverTimeout();

    this.hoverTimeout = setTimeout(() => {
      // Don't collapse if mouse is over a dropdown
      if (!this.isMouseOverDropdown) {
        this.isCollapsed = true;
      }
      this.hoverTimeout = null;
    }, 1000);
  }

  /**
   * Gets the rail out of the tray's way.
   *
   * The tray is opened from the rail's Notification row, so the pointer is over the rail and it is
   * hover-expanded to 280px at that moment — wide enough to sit across a tray anchored to the
   * collapsed width. Snapping it shut is what puts the tray where the design has it.
   */
  onAlertsTrayOpenChanged(isOpen: boolean): void {
    if (isOpen) {
      this.closeNavbarInstantly();
    }
  }

  closeNavbarInstantly() {
    this.clearHoverTimeout();
    this.isCollapsed = true;
  }

  private clearHoverTimeout(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  ngOnDestroy(): void {
    this.clearHoverTimeout();
    this._routerSubscription?.unsubscribe();
  }
}
